// frontend/src/components/WebchatVisitorInfo/index.js
import React, { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Link, Typography } from "@material-ui/core";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import formatSerializedId from "../../utils/formatSerializedId";

const fmt = (d) => (d ? new Date(d).toLocaleString("pt-BR") : "—");

// "Ocultar número" (lgpdHideNumber) para o perfil "user": a mesma máscara do painel do contato (ContactDrawer).
const maskNumber = (number) => {
  const n = String(number || "");
  if (!n) return n;
  const formatted = formatSerializedId(n) || n;
  return `${formatted.slice(0, -6)}**-**${n.slice(-2)}`;
};

/**
 * Painel do contato do webchat: o que o visitante digitou (não confirmado) e possíveis contatos iguais.
 * `hideNumber`: o número fica oculto para este usuário — telefone e contatos parecidos saem mascarados e sem link
 * (o link de Contatos leva o número no endereço).
 */
const WebchatVisitorInfo = ({ contactId, hideNumber = false }) => {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    let alive = true;
    if (!contactId) return undefined;
    api.get(`/webchat-admin/contacts/${contactId}/visitor`)
      .then(({ data }) => alive && setInfo(data))
      .catch(() => alive && setInfo(null));
    return () => { alive = false; };
  }, [contactId]);

  if (!info) return null;
  const shown = (number) => (hideNumber ? maskNumber(number) : number);
  return (
    <div style={{ padding: "8px 0" }}>
      <Typography variant="subtitle2">{i18n.t("webchatVisitor.title")}</Typography>
      <Typography variant="body2">
        {i18n.t("webchatVisitor.phone")}: {info.phone ? shown(info.phone) : i18n.t("webchatVisitor.noPhone")}
        {info.phone ? ` (${i18n.t("webchatVisitor.unconfirmed")})` : ""}
      </Typography>
      <Typography variant="body2" color="textSecondary">{i18n.t("webchatVisitor.since")}: {fmt(info.createdAt)}</Typography>
      <Typography variant="body2" color="textSecondary">{i18n.t("webchatVisitor.lastSeen")}: {fmt(info.lastSeenAt)}</Typography>
      {info.matches?.length > 0 && (
        <div style={{ marginTop: 6 }}>
          <Typography variant="body2">{i18n.t("webchatVisitor.maybeSame")}</Typography>
          {info.matches.map(m => (
            <Typography variant="body2" key={m.id}>
              {hideNumber
                ? `${m.name} · ${shown(m.number)}`
                : <Link component={RouterLink} to={`/contacts?search=${encodeURIComponent(m.number)}`}>{m.name} · {m.number}</Link>}
            </Typography>
          ))}
        </div>
      )}
    </div>
  );
};

export default WebchatVisitorInfo;
